import Store from "$common/utils/store";
import JsCrypto from '$proDirname/app/service/util-service/js-crypto';

const jsCrypto = JsCrypto(1, true);
export default class BossSocket {
  constructor() {
    if (!io) {
      throw '未引入 socket.io!'
    }
    //  socket 类
    this.WebSocket = WebSocket;
    this.notifications = {};
    //  io 对象
    this.io = io;
    //  域名前缀
    this.preFix = Vue.prototype?.ssr?.ioName ?? 'boss-merchant';
    //  socket url
    this.wsUrl = `${window.location.origin}${this.preFix && '/' + this.preFix || ''}/send`;
    // this.wsUrl = `http://localhost:7001${this.preFix && '/' + this.preFix || ''}/send`;
    //  获取登录信息
    this.user = JSON.parse(jsCrypto.decrypt(Store.loadObject('user_info')));
    console.log('this.user: ', this.user);
    //  创建 socket 对象
    this.socket = this.io(this.wsUrl, {
      path: `${this.preFix && '/' + this.preFix || ''}/socket.io`,
      transports: ['websocket'],
      secure: true,
      query: {
        user: encodeURIComponent(JSON.stringify(this.user))
      }
    })
    //  初始化连接状态
    this.connectStatus = 'pending';
    //  开始连接
    this.connect();
    this.start();
  }

  //  监听事件
  onEvent(name, callback) {
    this.socket.on(name, callback);
  }

  //  发送事件
  sendEvent(name, params) {
    const sendName = `${this.preFix || ''}${name}`;
    const queryParams = {
      bossSocketHeader: {
        user: this.user
      },
      params
    };
    this.socket.emit(sendName, queryParams);
  }

  //  连接 socket 回调函数
  connect() {
    this.onEvent('connect', params => {
      console.log('\n\nparams: ', params);
      this.connectStatus = 'success';
    });
  }

  close() {
    this.socket.close();
  }

  notify(params = {}) {
    const __isNotification = Store.loadObject('isNotification')
    if (__isNotification) {
      const {
        title = 'Notification',
        body = 'Tips',
        icon = require('$merchantAsserts/images/vipay_logo.png'),
        href
      } = params;
      if (window.webkitNotifications) {
        console.log('webkitNotifications!!');
        //  chrome老版本
        if ((window.webkitNotifications?.checkPermission() - 0) === 0) {
          console.log('webkitNotifications createNotification!!');
          const notif = window?.webkitNotifications?.createNotification(icon, title, body) ?? undefined;
          if (notif) {
            const noop = () => {
            };
            notif.display = noop;
            notif.onerror = noop;
            notif.onclose = noop;
            notif.onclick = function () {
              if (href) {
                window.location.href = decodeURIComponent(href);
              }
              this.cancel();
            }
            notif.replaceId = 'Meteoric';
            notif.show();
          }
        } else {
          alert(body);
        }
      } else if ('Notification' in window) {
        console.log('Notification!!');
        if (Notification && Notification.permission === 'granted') {
          console.log(`Notification.permission === 'granted'`);
          this.sendNotification(title, body, href);
        } else if (Notification && Notification.permission !== 'granted') {
          console.log(`Notification.requestPermission`);
          Notification.requestPermission(status => {
            console.log(`Notification.requestPermission status: `, status);
            if (Notification.permission !== status) {
              Notification.permission = status;
              this.sendNotification(title, body, href);
            }
          });
          this.sendNotification(title, body, href);
        }
      }
    }
  }

  sendNotification(title = 'Notification', msg = '', href) {
    const clickFunction = event => {
      if (href) {
        event.preventDefault();
        window.location.href = decodeURIComponent(href);
      }
    };
    Notification.onclick = clickFunction;
    const notification = new Notification(title, {
      icon: require('$merchantAsserts/images/vipay_logo.png'),
      body: msg
    });
    try {
      notification.close();
      notification.onclick = clickFunction;
    } catch (err) {
    }
  }

  showOrderNotify(params, title, path = '/') {
    const h = $vm.$createElement
    const notify = $vm.$notify({
      title: $vm.$i18n.t(title),
      position: 'bottom-right',
      message: h('div', {}, [h('div', {}, $vm.$i18n.t('order.orderNo') + '：' + params.pushObject.orderNo || ''), h('div', {}, $vm.$i18n.t('order.mark') + ': ' + (params.pushObject.eta || '') + ' #' + (params.pushObject.seqNo || ''))]),
      duration: 30000,
      onClick: () => {
        setTimeout(() => {
          this.closeNotification(params.pushObject.orderNo)
        }, 200)
        $vm.$router.replace({
          path: '/redirect' + path
        })
      }
    })
    this.notifications[params.pushObject.orderNo] = notify
  }

  closeNotification(orderNo) {
    this.notifications[orderNo].close()
    delete this.notifications[orderNo]
  }

  start() {
    this.onEvent('connect-callback', params => {
      console.log('Web Socket connect-callback params: ', params);
    });
    this.onEvent('notification', params => {
      console.log('notif: ', params);
      const isNotification = Store.loadObject('isNotification');
      const storeNo = Store.loadObject('storeNo');
      if (params.pushObject && params?.pushObject?.filter?.storeNo === storeNo && isNotification) {
        switch (params.pushType) {
          case 'new-order':
            this.showOrderNotify(params, 'store.preOrder')
            if (Store.loadObject('openAutoReceive')) {
              $vm.$store.dispatch('auto_receive_order')
              setTimeout(() => {
                $vm.$store.dispatch('total_order_count')
              }, 1500)
            } else {
              $vm.$store.dispatch('total_order_count')
            }
            break;
          case 'booking':
            this.showOrderNotify(params, 'order.appointmentPass', '/order-manager/appointment-order')
            $vm.$store.dispatch('total_order_count')
            break;
          case 'applying':
            this.showOrderNotify(params, 'order.applying', '/order-manager/refund-order')
            $vm.$store.dispatch('total_order_count')
            break;
          case 'refunding':
            this.showOrderNotify(params, 'order.refunding', '/order-manager/refund-order')
            $vm.$store.dispatch('total_order_count')
            break;
          case 'cancel':
            this.showOrderNotify(params, 'order.canceled', '/order-manager/all-order')
            $vm.$store.dispatch('total_order_count')
            break;
          default:
            break
        }
        // this.notify({
        //   body: params.body,
        //   title: params.title,
        //   href: params?.href ?? ''
        // });
      }
      console.log('Web Socket Notification params: ', params);
    });
    this.onEvent('test-event', params => {
      console.log('自测试自定义事件 test-event: ', params);
    });
    this.onEvent('close-boss-socket', params => {
      console.log('close-boss-socket: ', params)
      this.socket.close();
    });
  }
};
